module.exports = "<div class=\"list_item_filter\"></div>";